import React, { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Gallery } from "./Gallery";
import { Footer } from "./Footer";
import useReveal from "../lib/useReveal";

export const GaleriePage = () => {
    useReveal();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="App font-sans bg-[#F9F8F6] text-[#2C1E16]">
            <Navbar />
            <main>
                <Gallery />
            </main>
            <Footer />
        </div>
    );
};
